
// Represents complete workflow with variable phases
export const AdvancedAnalysisPhaseType = Symbol("AdvancedAnalysis")

export enum ExecutionPhaseType {

    DataCleaning = "data_cleaning",
    NCAAnalysis = "nca_analysis",
    CustomCalculations = "custom_calculations",
    Visualization = "visualization", //post processing
    CustomPlots = "custom_plots",
    CustomTables= "custom_tables",
    Reports = "custom_reports"
}

